// extracted by mini-css-extract-plugin
export default {"noParametersMessage":"noParametersMessage-jGdjq","inputs":"inputs-XsJSC"};